import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FileQuestion } from "lucide-react";
import PageWrap from "@/fileshare/components/PageWrap";
import { Button } from "@/fileshare/components/ui/button";

export default function NotFound() {
  return (
    <PageWrap className="max-w-md mx-auto px-6 pt-28 text-center">
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}>
        <div className="h-14 w-14 rounded-full bg-slate-100 flex items-center justify-center mx-auto mb-5">
          <FileQuestion className="h-7 w-7 text-slate-400" />
        </div>
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">Page not found</h1>
        <p className="text-sm text-slate-500 mt-2">The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
        <Link to="/fileshares"><Button className="mt-6 bg-blue-500 hover:bg-blue-600 text-white">Back home</Button></Link>
      </motion.div>
    </PageWrap>
  );
}
